import { useCallback, useEffect, useState } from "react";
import { addQcMailDomain, listQcMailLists } from "@/lib/manufacturing/builderAssistantClient";

const fieldClass =
  "w-full rounded-md border border-gray-300 bg-white px-2 py-1.5 text-sm dark:border-zinc-600 dark:bg-zinc-900";

export function ApprovedMailDomains() {
  const [domains, setDomains] = useState<string[]>([]);
  const [domain, setDomain] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    const res = await listQcMailLists();
    if (!res.ok) {
      setError(res.error);
      return;
    }
    setError(null);
    setDomains(res.data.approved_domains ?? []);
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  async function add() {
    if (!domain.trim()) return;
    setBusy(true);
    setError(null);
    const res = await addQcMailDomain(domain);
    setBusy(false);
    if (!res.ok) {
      setError(res.error);
      return;
    }
    setDomain("");
    await load();
  }

  return (
    <div className="space-y-2">
      <p className="text-xs text-gray-500 dark:text-zinc-400">
        These domains can receive group mail for this organization. Another organization can approve the same domain.
      </p>
      <p className="text-xs text-gray-600 dark:text-zinc-300">{domains.length ? domains.join(", ") : "None yet."}</p>
      <div className="flex flex-wrap items-end gap-2">
        <input
          className={`${fieldClass} min-w-48 flex-1`}
          value={domain}
          aria-label="Approved email domain"
          placeholder="Your Domain"
          onChange={(event) => setDomain(event.target.value)}
        />
        <button
          type="button"
          className="rounded-md bg-gray-900 px-3 py-1.5 text-sm text-white disabled:opacity-50 dark:bg-zinc-100 dark:text-zinc-900"
          disabled={busy || !domain.trim()}
          onClick={() => void add()}
        >
          Add domain
        </button>
      </div>
      {error ? <p className="text-xs text-rose-700 dark:text-rose-300">{error}</p> : null}
    </div>
  );
}
